/**
 * London Smoke & Cure — Njord activation readiness (no network calls).
 */

import { getNjordCloudRunUrl, getNjordRtdbUrl } from './njordConfig';

/** Cloud Run + RTDB env present — live data expected to work after operator deploys. */
export function isNjordLiveReady() {
    return Boolean(getNjordRtdbUrl() && getNjordCloudRunUrl());
}

/** Cloud Run URL only — registry, rooms, desired writes via Admin SDK API. */
export function isNjordApiReady() {
    return Boolean(getNjordCloudRunUrl());
}

/** RTDB URL only — live listeners. */
export function isNjordRtdbReady() {
    return Boolean(getNjordRtdbUrl());
}

/**
 * @returns {{ live: boolean, api: boolean, rtdb: boolean, phase: 'live'|'api-only'|'prep' }}
 */
export function getNjordActivationPhase() {
    const api = isNjordApiReady();
    const rtdb = isNjordRtdbReady();
    if (api && rtdb) return { live: true, api: true, rtdb: true, phase: 'live' };
    if (api) return { live: false, api: true, rtdb: false, phase: 'api-only' };
    return { live: false, api: false, rtdb: false, phase: 'prep' };
}
